<template>

  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Booking Agora Bilet Aktarımı</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile >
                    <v-list-tile-title>....</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-card color="grey lighten-1" flat>
              <v-layout row wrap>

                <v-flex xs12 sm6 md2>
                  <v-form ref="formtarih" v-model="valid" lazy-validation>

                  <tarihcomp :etiket="'Tarih Seçiniz'" :detaygizle="false" v-model="date"
                    v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihcomp>
                              </v-form>
                </v-flex>

                <v-flex>
                  <v-layout align-start="" justify-center column fill-height>
                    <div v-if="load1">
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="biletaktar()"
                        color="info" fab dark>
                        <v-icon>reply_all</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Biletleri Aktar</span>
                      </v-tooltip>
                    </div>

                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>

          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <v-toolbar size="120px" dark color="success">
                  <v-toolbar-title>Aktarılan Biletler</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
                </v-toolbar>
                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items=[20,50] :loading="progress" :items="itemsok"
                    :search="search3">
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.biletNo }}</td>
                        <td class="text-xs-left">{{ props.item.aciklama }}</td>
                        <v-btn icon class="mx-0" @click="git(props.item)">
                          <v-icon color="teal">search</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>

              </v-flex>
              <v-flex xs12 sm6 md6>

                <v-toolbar size="120px" dark color="red">
                  <v-toolbar-title>Aktarılamayan Biletler</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search4" label=" Ara" append-icon="search"></v-text-field>
                </v-toolbar>
                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items=[20,50] :loading="progress" :items="itemsno"
                    :search="search4">
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.biletNo }}</td>
                        <td class="text-xs-left">{{ props.item.aciklama }}</td>
                        <v-btn icon class="mx-0" @click="git(props.item)">
                          <v-icon color="teal">search</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search4 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
              </v-snackbar>
            </v-layout>
          </v-container>
           <v-dialog v-model="load" hide-overlay persistent width="400">
      <v-card color="primary" dark>
        <v-card-text>
          Lütfen Bekleyiniz...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from "@/components/app/customcomp/tarihim"

  export default {
    data() {
      return {
                valid:true,

        search: '',
        headers: [{
            text: 'Bilet No',
            value: 'biletNo'
          },
          {
            text: 'Durum',
            value: 'aciklama'
          }

        ],
        EkstreHesap: {

          SirketKodu: '',
          Masraf: {
            Code: ''
          },
          BaslangicTarih: '',
          BitisTarih: '',
          Cari: {
            Kod: ''
          },
          RaporTip: '0'

        },
        currentDebtTotal: 0,
        currentCreditTotal: 0,
        debtTotal: 0,
        creditTotal: 0,
        StartDate: null,
        EndDate: null,
        itemsok: [],
        itemsno: [],
        statecari: [],
        MasrafMerkezi: [],
        searchcari: '',
        dictionary: {
          custom: {
            masrafkodu: {
              required: () => 'Lütfen seçiminizi yapınız'
            },
            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        evraktipi: [],
        anahesap: [],
        tumsirketler: '',
        search4: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        progress: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    components: {
      'tarihcomp': tarihcomp
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },
    methods: {

      biletaktar: biletaktar,

      git: git
    }
  }

  function git(v) {

    console.log('git' + v.bilet)
    var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.bilet.HavayoluKodu + '&biletno=' + v.bilet
      .BiletNo + '&ucustipi=' + v.bilet.UcusTipi
    window.open(url, '_blank')
  }



  function biletaktar() {

      if (this.$refs.formtarih.validate()) {


        this.load = true
        this.load1 = false


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
          tarih: this.date
        }

        this.$http.post(auth.API_URL + 'api/ArkmanTicketStream/BookingAgoraStream', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          var aktarilan = 0

          this.itemsok = []
          this.itemsno = []

          response.body.forEach(element => {
            if (element.aciklama == " - BASARILI. ") {
              this.itemsok.push(element)
              aktarilan = aktarilan + 1
            } else {
              this.itemsno.push(element)
            }
          });
          this.text1 = "toplam " + aktarilan + " adet bilet aktarımı tamamlandı"
          this.snackbar = true
          this.load = false
          this.load1 = true


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
          }
        })

      }

  }



  function beforeMount() {

  }

</script>
<style>
</style>